import { Spacing } from '../../utils/editorReactIcons';
export { Spacing };
export default Spacing;
